(() => {
  if (customElements.get('component-video')) {
    return;
  }

  class ComponentVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.attachHandlers();
    }
    
    initElements() {
      this.video = this.querySelector('video');
      this.playBtn = this.querySelector('[data-play-button]');
      this.pauseBtn = this.querySelector('[data-pause-button]');
    }

    attachHandlers() {
      this.video.addEventListener('click', () => {
        if (this.classList.contains('is-playing')) {
          this.pause();

          return;
        }

        this.play();
      });

      this.playBtn.addEventListener('click', () => {
        this.play();
      });

      this.pauseBtn.addEventListener('click', () => {
        this.pause();
      });

      this.video.addEventListener('pause', () => {
        this.classList.remove('is-playing');
      });

      this.debouncedMouseMove = debounce(() => {
        this.classList.remove('is-hovering');
      }, 300);

      this.video.addEventListener('mousemove', () => {
        if (!this.classList.contains('is-playing')) {
          return;
        }

        this.classList.add('is-hovering');

        this.debouncedMouseMove();
      });
    }

    play() {
      this.video.play();

      this.classList.add('is-playing');
    }

    pause() {
      this.video.pause();

      this.classList.remove('is-playing');
    }
  }

  customElements.define('component-video', ComponentVideo);
})();
